module.exports = __webpack_public_path__ + "static/media/inf_90og91.266ef821.mp3";